import { useStanQuery } from '@/queries';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import { getTaxDocuments } from '@/lib/api/settings';

/**
 * Query hook to fetch available tax documents (1099s, expense reports)
 * Returns reports grouped by year in descending order
 */
export const useTaxDocuments = () => {
    return useStanQuery({
        queryKey: [QUERY_KEYS.TAX_DOCUMENTS],
        queryFn: getTaxDocuments,
        staleTime: 1000 * 60 * 10, // 10 minutes - tax documents don't change often
        meta: {
            error: {
                feature: SENTRY_FEATURES.SETTINGS,
                sentryMessage: '[SETTINGS] failed-to-fetch-tax-documents',
            },
        },
    });
};
